import { type Msg } from '@halo/chat-sdk-react';
import { MessageReplies } from '@halo/ui-chat-react';

// Message
export interface MsgFooterRepliesProps {
  message: Msg;
}

export const MsgFooterReplies = memo(function MsgFooterReplies({
  message,
}: MsgFooterRepliesProps) {
  return <MessageReplies count={message.reply_list?.length} />;
});
